import cookie from 'react-cookies';
import { HOME_SAVE_TOKEN_FROM_ORGANIZATION } from '../../features/home/redux/constants';
import { getCookie } from '../../features/home/app_util';

function checkAuthorization(dispatch) {
  const token = getCookie('token');
  if (token) {
    //Verify Token is valid or not
    console.log('Cookies has token ', token);
    dispatch({
      type: HOME_SAVE_TOKEN_FROM_ORGANIZATION,
      token,
    });
    return { access: true };
  }
  return { access: false };
}

export const checkWidgetAuthorization = ({ dispatch, getState }, ...rest) => {
  const { token } = getState().home;
  if (token) {
    console.log('Storage has token ', token);
    return {
      access: true,
    };
  }
  console.log("I don't have token, now check from cookies storage");
  return checkAuthorization(dispatch);
};

export const checkLocationTokenAndAuthorize = (store, rest) => {
  let searchParams = new URLSearchParams(rest.location.search);
  let token = searchParams.get('token');

  if (token) {
    const expires = new Date();
    expires.setDate(Date.now() + 1000 * 60 * 60 * 24);
    cookie.save('token', token, { path: '/', expires });
    store.dispatch({
      type: HOME_SAVE_TOKEN_FROM_ORGANIZATION,
      token: token,
    });
    return { access: true };
  }
  return { access: false };
};
